import { render } from "./NewsCreate.vue?vue&type=template&id=a26d6bcc"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"

import "./NewsCreate.vue?vue&type=style&index=0&id=a26d6bcc&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__